import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknown = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 18 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_4304_54073)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M7.91276 14.28L3.15945 9.47428L12.8977 9.715L7.91276 14.28Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M6.15203 9.86062C6.17704 8.84882 6.40109 7.85184 6.8114 6.92663C7.22171 6.00142 7.81023 5.16608 8.54337 4.46831C9.27651 3.77054 10.1399 3.22401 11.0843 2.85992C12.0286 2.49582 13.0354 2.3213 14.0472 2.34631L13.9459 6.44547C13.4724 6.43377 13.0013 6.51544 12.5593 6.68583C12.1174 6.85621 11.7134 7.11197 11.3703 7.43851C11.0272 7.76504 10.7518 8.15596 10.5598 8.58893C10.3677 9.0219 10.2629 9.48845 10.2512 9.96195L6.15203 9.86062Z",
				fill: "currentColor"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 17,
			height: 16,
			rx: 1.5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4304_54073",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 17,
				rx: 2,
				fill: "currentColor"
			})
		}) })
	]
});
export default SvgUnknown;
